import DropDownMenu from '@/sections/NavBar/DropDownMenu'
import { ProductDesktopMenu } from '@/sections/NavBar/ProductMenu'

const ProductDropDownMenu = () => {
    return (
        <DropDownMenu header={'Product'}>
            <ProductDesktopMenu />
        </DropDownMenu>
    )
}

export default ProductDropDownMenu
